import React from 'react';
import {ulid} from 'ulid';

import {AsyncWrapperOptions} from '../api/asyncWrapper';
import {MoodLight} from '../types';
import {useSaveMoodLight} from './useSaveMoodLight';

export const useDuplicateMoodLight = (
  options: AsyncWrapperOptions<MoodLight>,
) => {
  const [state, action] = useSaveMoodLight(options);

  const save = React.useCallback(
    (moodLight: MoodLight, o?: {keepOriginalName?: boolean}) => {
      const id = ulid();

      action({
        ...moodLight,
        id,
        name: o?.keepOriginalName
          ? moodLight.name
          : `Copy of ${moodLight.name}`,
        projector: {
          ...moodLight.projector,
          meta: {
            ...moodLight.projector.meta,
            originalMoodLightId: moodLight.id,
          },
        },
      });
    },
    [action],
  );

  return React.useMemo(() => [state, save] as const, [state, save]);
};
